module.exports = __webpack_public_path__ + "static/media/next-arrow.d030afbc.svg";